(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dffrnt-studio"] && !Shopify.designMode) return;
  try {
    
function initDffrntStudioDate() {
  const date = document.getElementById('StudioDate');
  if (!date || date.dataset.ready) return;
  date.dataset.ready = 'true';
  const today = new Intl.DateTimeFormat('en-CA', { timeZone: 'America/New_York', year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date());
  date.min = today;
  date.addEventListener('input', () => {
    date.setCustomValidity('');
    if (!date.value) return;
    const selected = new Date(date.value + 'T12:00:00');
    const occurrence = Math.ceil(selected.getDate() / 7);
    const eligible = [4, 6].includes(selected.getDay()) && [1, 3, 5].includes(occurrence) && date.value >= today;
    if (!eligible) date.setCustomValidity(date.dataset.dateError);
  });
}
initDffrntStudioDate();
document.addEventListener('shopify:section:load', initDffrntStudioDate);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
